import React from 'react';
import UserContext from './UserContext';
import UserInfo from './UserInfo';
import SessionInfo from './SessionInfo/SessionInfo';
import { EventMarker, SearchUser } from '@fullstory/proto/fs/services/alexa';
import { SessionExpanderRoute } from '@fullstory/routes';
import { Box, Flex, SpaceScale } from '@fullstory/components';
import { Timestamp } from '@fullstory/proto/google/protobuf';

export const USER_LIST_ROW_GAP_SPACING: SpaceScale = 16;

interface UserListRowProps {
  /** The SearchUser we are rendering. */
  user: SearchUser;
  sessionLink: SessionExpanderRoute;
  eventMarkers: EventMarker[];
  lastSessionWatched: boolean;
  orgId: string;
  gravatarURL?: string;
  /**
   * The date to reference when deciding to render the session as 'online'.
   * Passed in as a prop so each row doesn't create its own new Date() to compare to.
   */
  now: Date;
  smallView: boolean;
  onPlayClick?: () => void;
  onUserInfoClick: () => void;
  completeSessions: boolean;
  newTab?: boolean;
  autoSelect?: boolean;
}

export const UserListRow: React.FC<UserListRowProps> = ({
  eventMarkers,
  gravatarURL,
  lastSessionWatched,
  now,
  onPlayClick,
  onUserInfoClick,
  sessionLink,
  orgId,
  user,
  smallView,
  completeSessions,
  newTab,
  autoSelect,
}) => (
  <Box data-component="UserListRow" margin={[USER_LIST_ROW_GAP_SPACING, 0]}>
    <Flex align-items="center" testId="user-list-row">
      <UserInfo
        indivId={`${user.indvId}`}
        displayName={user.displayName}
        created={Timestamp.toDate(user.createdAt) ?? new Date()}
        email={user.email}
        gravatarURL={gravatarURL}
        onClick={onUserInfoClick}
      />
      <SessionInfo
        user={user}
        now={now}
        orgId={orgId}
        isWatched={lastSessionWatched}
        eventMarkers={eventMarkers}
        sessionLink={sessionLink}
        onPlayClick={onPlayClick}
        onUserInfoClick={onUserInfoClick}
        completeSessions={completeSessions}
        newTab={newTab}
        autoSelect={autoSelect}
      />
      {!smallView && (
        <UserContext
          location={user.lastMatchingCity}
          device={user.lastMatchingDevice}
          os={user.lastMatchingOperatingSystem}
          isServerOnly={sessionLink.route.length <= 0}
          integrationName={user.lastMatchingCaptureSourceIntegration}
        />
      )}
    </Flex>
  </Box>
);
